export const RESPONSES = [
  { value: 'not_delivered', label: 'Not Delivered', tone: 'red' },
  { value: 'not_read', label: 'Not Read', tone: 'neutral' },
  { value: 'client_read', label: 'Client Read', tone: 'amber' },
  { value: 'all_good', label: 'All Good', tone: 'green' }
]

export const QUEUES = {
  upcoming: { label: 'Upcoming', description: 'Planned contacts that are still open.' },
  needs_attention: { label: 'Needs attention', description: 'Overdue contacts, missing data and delivery problems.' },
  completed: { label: 'Archive', description: 'Completed contacts, newest first.' }
}

export const ACTION_LABELS = {
  claim: 'Take',
  assign: 'Assign',
  complete: 'Done',
  set_response: 'Response'
}

export const ACTION_ICONS = {
  claim: 'pi-user-plus',
  assign: 'pi-users',
  complete: 'pi-check',
  set_response: 'pi-comment'
}

export function responseOption(value) {
  return RESPONSES.find(option => option.value === value) || null
}

export function dateOnly(value) {
  if (!value) return '—'
  const date = new Date(`${String(value).slice(0, 10)}T12:00:00`)
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

export function dateTime(value) {
  if (!value) return '—'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' })
}

export function dueLabel(task) {
  return task.all_day ? dateOnly(task.due_at) : dateTime(task.due_at)
}

export function safariDates(group) {
  if (!group || !group.tour_start || !group.tour_end) return '—'
  const start = new Date(`${String(group.tour_start).slice(0, 10)}T12:00:00`)
  const end = new Date(`${String(group.tour_end).slice(0, 10)}T12:00:00`)
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return `${dateOnly(group.tour_start)} – ${dateOnly(group.tour_end)}`
  const sameYear = start.getFullYear() === end.getFullYear()
  const sameMonth = sameYear && start.getMonth() === end.getMonth()
  if (sameMonth && start.getDate() === end.getDate()) return dateOnly(group.tour_start)
  if (sameMonth) return `${start.getDate()}–${dateOnly(group.tour_end)}`
  if (sameYear) return `${start.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })} – ${dateOnly(group.tour_end)}`
  return `${dateOnly(group.tour_start)} – ${dateOnly(group.tour_end)}`
}

export function errorMessage(error, fallback) {
  const details = error && error.response && error.response.data && error.response.data.details
  return typeof details === 'string' && details ? details : fallback
}
